import { TransactionStatus } from '../const/transactionStatus';
var completedAndCanceledStatuses = [
    TransactionStatus.SET_8,
    TransactionStatus.SET_9,
    TransactionStatus.SET_10,
    TransactionStatus.SET_11,
    TransactionStatus.SET_12,
    TransactionStatus.SET_13,
    TransactionStatus.SET_14,
    TransactionStatus.SET_15,
    TransactionStatus.SET_16,
    TransactionStatus.SET_17,
    TransactionStatus.SET_18,
    TransactionStatus.SET_19,
    TransactionStatus.SET_20,
    TransactionStatus.SET_21,
    TransactionStatus.SET_23,
    TransactionStatus.SET_24,
    TransactionStatus.SET_25
];
var isNotCompletedOrCanceled = function (statusValue) {
    return !completedAndCanceledStatuses.includes(statusValue);
};
export default isNotCompletedOrCanceled;
//# sourceMappingURL=isNotCompletedOrCanceled.js.map